import React from 'react'
import Slider from 'wix-base-ui/lib/controls/slider'

class LabeldSlider extends React.Component {
    render() {
        return (
            <div className="richtext-slider-container">
                <span className="label">{this.props.label}</span>
                <Slider value={this.props.value}
                        onChange={this.props.onChange}
                        onSlideEnd={this.props.onSlideEnd}
                        min={this.props.min} max={this.props.max} step={this.props.step}/>
            </div>
        )
    }
}

LabeldSlider.propTypes = {
    label: React.PropTypes.string,
    value: React.PropTypes.number,
    onChange: React.PropTypes.func,
    onSlideEnd: React.PropTypes.func,
    min: React.PropTypes.number,
    max: React.PropTypes.number,
    step: React.PropTypes.number
}

module.exports = LabeldSlider



// WEBPACK FOOTER //
// ./src/components/toolbar/labeldSlider.jsx